<script lang="ts">
	import SearchIcon from 'assets/svg/searchIcon.svg?component';
	import activeLocale from 'stores/activeLocale';
	import { searchArticle } from 'services/search/searchArticle';

	export let dark: boolean;
	export let placeholder = 'Search';
	export let setArticles: (articles) => void;
	export let page = 1;
	export let query = '';
	export let handleQuery: (query: string) => void;
	export let handleTotalPages: (pages: number) => void;

	export let category;

	const search = async () => {
		if (!query.trim().length) {
			return;
		}
		try {
			const articles = await searchArticle(query, page, category, $activeLocale.locale);
			setArticles(articles.results);
			handleTotalPages(articles.pages);
			handleQuery(query);
		} catch (e) {
			console.log(e);
		}
	};

	async function handleEnter(e: KeyboardEvent) {
		if (e.key === 'Enter') await search();
	}
</script>

<div class="wrapper">
	<div class="search-wrapper" class:dark class:not-empty={query}>
		<input class="input" type="text" {placeholder} bind:value={query} on:keypress={handleEnter} />
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div class="icon-wrapper" on:click={search}>
			<SearchIcon width="12" height="12" class="search-icon center" />
		</div>
	</div>
</div>

<style lang="scss">
	@import 'articleSearch';
</style>
